import { render, staticRenderFns } from "./responsible_person_task.vue?vue&type=template&id=8218516e&scoped=true"
import script from "./responsible_person_task.vue?vue&type=script&lang=js"
export * from "./responsible_person_task.vue?vue&type=script&lang=js"
import style0 from "./responsible_person_task.vue?vue&type=style&index=0&id=8218516e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8218516e",
  null
  
)

export default component.exports